export interface SitePlanArrayEvidence {
  id: string;
  label: string | null;
  panelCount: number | null;
  tilt: number | null;
  azimuth: number | null;
  rawValues: {
    panelCount: string | null;
    tilt: string | null;
    azimuth: string | null;
  };
  pageNumbers: number[];
  analysis: string;
}

export interface SitePlanArrayComparison {
  comparisonId: string;
  applicationArrayId: string;
  applicationOrder: number;
  applicationArray: SitePlanArrayEvidence;
  sitePlanArray: SitePlanArrayEvidence | null;
  actualValue: string;
  extractedValue: string;
  currentValue: string;
  matchStatus: 'Matched' | 'Unmatched';
  analysis: string;
  success: boolean;
  resultStatus: 'Open' | 'Approved' | 'Flagged';
  isCorrect: boolean | null;
}

export interface SitePlanArrayDetailsContent {
  contentType: 'sitePlanArrayDetails';
  schemaVersion: 1;
  success: boolean;
  analysis: string;
  metadata: {
    prompt: unknown;
    model: { endpoint: string; modelVersion: string };
    createdDateTimeUTC: string;
    associatedFile: string | null;
  };
  comparisons: SitePlanArrayComparison[];
  unmatchedSitePlanArrays: {
    sitePlanArray: SitePlanArrayEvidence;
    analysis: string;
  }[];
  summary: {
    applicationArrayCount: number;
    sitePlanArrayCount: number;
    matchedCount: number;
    unmatchedApplicationCount: number;
    unmatchedSitePlanCount: number;
    allMatched: boolean;
  };
}

/** Only review values belong in the form; evidence stays in the result blob. */
export interface SitePlanArrayReviewDraft {
  applicationId: string;
  instanceId: number;
  values: Record<string, string>;
}
